import { useEffect, useState } from "react";

function format(timeZone?: string) {
  try {
    return new Date().toLocaleDateString("es-AR", {
      weekday: "long",
      day: "numeric",
      month: "long",
      year: "numeric",
      timeZone,
    });
  } catch {
    return new Date().toLocaleDateString("es-AR", { weekday: "long", day: "numeric", month: "long", year: "numeric" });
  }
}

/** Today's date in the visitor's timezone, resolved from their IP (falls back to the browser timezone). */
export function useVisitorDate() {
  const [date, setDate] = useState(() => format());

  useEffect(() => {
    const controller = new AbortController();
    const timeout = window.setTimeout(() => controller.abort(), 3000);
    fetch("https://ipapi.co/json/", { signal: controller.signal })
      .then((r) => (r.ok ? r.json() : null))
      .then((data: { timezone?: string } | null) => {
        if (data?.timezone) setDate(format(data.timezone));
      })
      .catch(() => undefined)
      .finally(() => window.clearTimeout(timeout));
    return () => {
      controller.abort();
      window.clearTimeout(timeout);
    };
  }, []);

  return date;
}
